module.exports = __webpack_public_path__ + "static/media/01.5f7afac6.png";